import React, { useState } from 'react';
import { Form, FormGroup, Input } from 'reactstrap';
import '../styles/contact-form.css';
import { contactUs } from '../util/api';
import { useNavigate } from 'react-router-dom';

const ContactForm = () => {
  const navigate = useNavigate();
  const submitHandler = e => {
    e.preventDefault();

    const obj = {
      userName: name,
      message: message,
      phone: phone,
      email: email,
    };
    contactUs(obj).then(res => {
      alert('Your message is sent');
      navigate('/Home');
    });
  };

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [phone, setPhone] = useState('');
  return (
    <Form onSubmit={submitHandler}>
      <FormGroup className="contact__form d-inline-block mb-4 me-4">
        <Input
          type="text"
          placeholder="Your Name"
          required
          onChange={e => setName(e.target.value)}
        />
      </FormGroup>
      <FormGroup className="contact__form d-inline-block mb-4 ms-1">
        <Input
          type="text"
          placeholder="Phone"
          required
          onChange={e => setPhone(e.target.value)}
        />
      </FormGroup>
      {/* <FormGroup className="contact__form d-inline-block mb-4 me-4">
        <Input type="text" placeholder="Phone" required />
      </FormGroup> */}
      <FormGroup className="contact__form d-inline-block mb-4 ms-1">
        <Input
          type="text"
          placeholder="Email"
          required
          onChange={e => setEmail(e.target.value)}
        />
      </FormGroup>

      <FormGroup className="contact__form w-100 ">
        <textarea
          name=""
          id=""
          className="w-100 p-3"
          rows="5"
          placeholder="Write your message here"
          required
          onChange={e => setMessage(e.target.value)}
        ></textarea>
      </FormGroup>
      <button className="btn mt-4" type="submit">
        Send Message
      </button>
    </Form>
  );
};

export default ContactForm;
